import { createContext, type ReactNode } from "react";

export interface ConfirmDialogOptions {
  title?: ReactNode;
  content?: ReactNode;
  confirmButtonTitle?: ReactNode;
  isDestructive?: boolean;
}

export interface ConfirmDialogApi {
  /** Resolves `true` when the user confirms and `false` when the dialog is cancelled. */
  confirm: (options: ConfirmDialogOptions) => Promise<boolean>;
  /** Delete confirmation with the default title, text and a red button. */
  confirmDelete: (options?: ConfirmDialogOptions) => Promise<boolean>;
}

export const ConfirmDialogContext = createContext<ConfirmDialogApi | null>(null);
